// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let FormV5 = require("../../uikit/reason/atoms/Form/FormV5.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__HelpLabel = require("../../uikit/reason/atoms/Form/Form__HelpLabel.bs.js");
let RichTextEditorV5 = require("../common/Components/RichTextEditorV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let SharingContactsInputRelay = require("./SharingContactsInputRelay.bs.js");

function ShareDraftFormRelay(props) {
  let form = props.form;
  let onCancel = props.onCancel;
  let onSubmit = props.onSubmit;
  let initialMessage = React.useRef(form.input.message);
  let match = form.subjectResult;
  let tmp;
  tmp = match !== undefined && match.TAG !== "Ok" ? JsxRuntime.jsx(FormV5.$$Error.make, {
      children: match._0
    }) : null;
  let match$1 = form.status;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  let match$2 = form.status;
  let tmp$2;
  tmp$2 = typeof match$2 !== "object" ? match$2 !== "Editing" : match$2.TAG === "Submitting";
  let match$3 = form.status;
  let tmp$3;
  tmp$3 = typeof match$3 !== "object" ? (
      match$3 === "Editing" ? null : JsxRuntime.jsx(Alert.Success.make, {
          title: "Draft shared"
        })
    ) : (
      match$3.TAG === "Submitting" ? null : JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Alert.$$Error.make, {
            title: "There was an error sharing the draft. Please try again"
          }),
          className: "mt-4"
        })
    );
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Form__Label.make, {
                labelText: "Add your client(s)"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Form__HelpLabel.make, {
                    children: "Separate multiple emails with return"
                  }),
                  JsxRuntime.jsx(SharingContactsInputRelay.make, {
                    value: form.input.contacts,
                    onChange: contacts => form.updateContacts((input, contacts) => ({
                      contacts: contacts,
                      subject: input.subject,
                      message: input.message
                    }), contacts),
                    onBlur: param => form.blurContacts(),
                    validationResult: form.contactsResult,
                    placeholder: "Enter your client's email address(es)"
                  })
                ],
                className: "mt-2"
              })
            ]
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Form__Input.make, {
                labelText: "Edit the email subject",
                onChange: evt => {
                  let value = Form__Helpers.eventValue(evt);
                  form.updateSubject((input, subject) => ({
                    contacts: input.contacts,
                    subject: subject,
                    message: input.message
                  }), value);
                },
                onBlur: param => form.blurSubject(),
                status: Stdlib_Option.flatMap(form.subjectResult, x => {
                  if (x.TAG === "Ok") {
                    return "ok";
                  } else {
                    return "error";
                  }
                }),
                value: form.input.subject
              }),
              tmp
            ]
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Form__Label.make, {
                labelText: "Add a message for your client",
                optionalText: "optional"
              }),
              JsxRuntime.jsx(RichTextEditorV5.make, {
                initialContent: initialMessage.current,
                onChange: text => form.updateMessage((input, message) => ({
                  contacts: input.contacts,
                  subject: input.subject,
                  message: message
                }), text),
                onBlur: param => form.blurMessage(),
                toolbar: "none",
                height: "short"
              })
            ]
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                  onClick: param => onCancel(),
                  disabled: tmp$1,
                  _type: "button",
                  children: "Cancel"
                }),
                className: "mr-2"
              }),
              JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                onClick: extra => Form__Helpers.preventDefault(() => onSubmit(), extra),
                disabled: tmp$2,
                children: "Share Draft"
              })
            ],
            className: "flex items-center justify-end"
          })
        ],
        className: "space-y-6"
      }),
      JsxRuntime.jsx("div", {
        children: tmp$3,
        className: "flex justify-end mt-2 ",
        role: "status"
      })
    ]
  });
}

let make = ShareDraftFormRelay;

exports.make = make;
/* Alert Not a pure module */
